module.exports = __webpack_public_path__ + "media/images/pic/hero/flowers-8414719eda98442f9d8572764a4beb2b.png";